import { useSelector } from 'react-redux';
import { stationSelector } from 'Features/App/Dictionaries/selectors';
import { getStationPath } from 'Features/StationsNew/Station/Components';

export const useStationInfo = (stationId: number) => {
  const station = useSelector(stationSelector(stationId));
  const name = station?.name || `[id:${stationId}]`;
  const path = Number.isInteger(station?.id) ? getStationPath(stationId) : null;
  return { name, path };
};
